import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ViewListIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M3 14H7V10H3V14ZM3 19H7V15H3V19ZM3 9H7V5H3V9ZM8 14H21V10H8V14ZM8 19H21V15H8V19ZM8 5V9H21V5H8Z" />
  </SvgIcon>
);
